import React, { PureComponent } from "react";
import TextField from '@material-ui/core/TextField';
import * as styles from "./style.css";

export default class UQFormsTextField extends PureComponent {
  render() {
    const { labelClassName, error, isMemorialTheme, ...other } = this.props;
    const margin = this.props.margin ? this.props.margin : 'normal';
    const errorProps = error != null ? {
      error: true,
      helperText: error
    } : {};
    return (
      <TextField
        {...errorProps}
        {...other}
        margin={margin}
        className={styles.container}
        InputLabelProps={{ className: `${styles.label} ${labelClassName} ${isMemorialTheme ? styles.labelMemorail : ''}`, classes: { shrink: styles.labelShrink } }}
        InputProps={{ className:`${styles.input} ${isMemorialTheme ? styles.inputMemorial : ''}` }}
      />
    );
  }
}




// WEBPACK FOOTER //
// ./src/app/modules/uq-forms/components/text-field/index.jsx